(function($, undefined) {
	
	'use strict';
    var slider;
    var sliderNextBtn;
    var sliderPrevBtn;
	
    
    var nextSlide = function(){
        slider.slick('slickNext');
    };
    
    var prevSlide = function(){
        slider.slick('slickPrev');
    };
	
	var init = function () {
		slider = $('.home-slider');
		slider.slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 5000,
			speed: 500,
			arrows: false,
			cssEase: 'cubic-bezier(.58,.24,.52,.93)',
			fade: true
		});
        slider.css("visibility", "visible");
        
        sliderNextBtn = $(".slick-next");
        sliderPrevBtn = $(".slick-prev");
        sliderNextBtn.on("click", nextSlide);
        sliderPrevBtn.on("click", prevSlide);
			
	};
	
	init();
	
})(jQuery);
